import Decimal from 'decimal.js';

import type { InternalAxiosRequestConfig } from 'axios';

/**
 * PHP only populates multipart/form-data bodies for POST requests, so
 * PATCH/PUT requests carrying FormData must go over the wire as POST with
 * Laravel's `_method` spoof field. The backend routes and validates the
 * request under the original verb.
 */
export const spoofMultipartMethodInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const method = config.method?.toLowerCase();
    if ((method === 'patch' || method === 'put') && config.data instanceof FormData) {
        config.data.append('_method', method.toUpperCase());
        config.method = 'post';
    }
    return config;
};

/**
 * Recursively builds a FormData object starting from a given value.
 */
export const recursivelyBuildFormData = (data: any, formData: FormData, dataKey: string) => {
    console.log(dataKey, data);
    if (data === undefined) {
        return;
    }
    if (data instanceof Blob) {
        formData.append(dataKey, data);
    } else if (data instanceof Date) {
        formData.append(dataKey, data.toISOString());
    } else if (data instanceof Decimal) {
        formData.append(dataKey, data.toString());
    } else if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        for (const [subKey, subValue] of Object.entries(data)) {
            recursivelyBuildFormData(subValue, formData, `${dataKey}[${subKey}]`);
        }
    } else if (data === null) {
        formData.append(dataKey, '');
    } else if (Array.isArray(data)) {
        data.forEach((subValue, subIdx) => {
            recursivelyBuildFormData(subValue, formData, `${dataKey}[${subIdx}]`);
        });
    } else if (typeof data === 'string') {
        formData.append(dataKey, data);
    } else {
        formData.append(dataKey, String(data));
    }
};
